var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankNavLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_143_67",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3{fill:#1c9ad6;opacity:.2}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1596",
    fill: "none",
    d: "M0 0H23V23H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6339",
    transform: "translate(129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    fill: "#03002f",
    d: "M-106.575 20.5h-.864V8.667a.375.375 0 0 0-.375-.375h-4.325V1.516a.375.375 0 0 0-.375-.375h-9.993a.375.375 0 0 0-.375.375v6.8h-4.3a.375.375 0 0 0-.375.375v11.821h-.863a.375.375 0 0 0-.375.375v.6a.375.375 0 0 0 .375.375h21.85a.375.375 0 0 0 .375-.375v-.6a.375.375 0 0 0-.38-.387zm-16.319-.027h-3.266V9.709h3.266zm9.38.01H-121.478V2.526h7.969zm4.668-.011h-3.262V9.7h3.262z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1620",
    d: "M0 0H1.838V8.985H0z",
    className: "cls-3",
    transform: "translate(-125.446 10.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    d: "M-115.019 14.622v5.866h-5.065v-5.866a1 1 0 0 1 1-1h3.065a1 1 0 0 1 1 1z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1621",
    d: "M0 0H1.838V8.985H0z",
    className: "cls-3",
    transform: "translate(-111.396 10.598)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNavLogo);
export default __webpack_public_path__ + "static/media/bankNavLogo.5b49c5283345b48fac22feba3e708000.svg";
export { ForwardRef as ReactComponent };